export const sksBuyPriceRate = 1.02;
export const sksSellPriceRate = 0.99;
export const sksFeeRate = 0.005;
export const priceDecimals = 1000000;
export const skyweaverBuyPriceRate = 1.03775;
export const skyweaverSellPriceRate = 0.96225;
